import { Component } from '@angular/core';
import { FormService } from '../../services/form.service';

@Component( {
	selector: 'app-thank-you-step',
	templateUrl: './thank-you.component.html',
	styleUrls: ['./thank-you.component.scss']
} )
export class ThankYouStepComponent {

	public loadingAnimationBeforeRedirecting : boolean = false;

	constructor( public formService: FormService ) {

	}

	waitAndGoToDashboard( event:any ) {

		// Stop linking
		event.preventDefault();

		// Telemetry: user explicitly clicked through to the consumer dashboard
		// (DEV-6453) rather than waiting for the auto-redirect. sendBeacon
		// survives the imminent navigation.
		this.formService.logFormAction( 'dashboard_open_clicked', 'thankYou' );

		// Wait time 1.5s
		var waitTime = 1500;

		// Add loader in button
		this.loadingAnimationBeforeRedirecting = true;

		// Wait
		setTimeout( () => {
			window.location.href = this.formService.dashboardUrl;
		}, waitTime );
	}
}
